import { Toast } from 'react-bootstrap';
import React from 'react';
import styles from "./toast.module.css"
export default function MyToast ({text ,type , show , setShow,autohide=true}){

  const getVariant = () => {
    switch(type) {
      case 'error':
        return 'bg-danger text-white';
      case 'success':
        return 'bg-success text-white';
      default:
        return 'bg-info text-white';
    }
  }
  return (
    <Toast   className={`${styles.container} ${getVariant()}`}  show={show} onClose={() => setShow(false)} delay={5000} autohide={autohide}>
      <Toast.Header className={styles.header}>
         <strong className="mr-auto">{type}</strong>
      </Toast.Header>
      <Toast.Body>{text}</Toast.Body>
    </Toast>
  );
}
